/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import baseApi from '@features/base/BaseSlice';
import site from './site';
import {
  EmployersApiProps,
  FacilitiesApiProps,
  SiteApiProps,
  SectionsApiProps,
  AreaSectionApiProps,
  AreaSectionFilterProps,
  SiteChildsApiProps,
  ModuleParams,
  ModulesApiProps,
  Site,
  ReportApiProps,
  JobTypeApiProps,
} from './types';

const siteTag = baseApi.enhanceEndpoints({ addTagTypes: [site.tagType] });

const siteApi = siteTag.injectEndpoints({
  endpoints: (builder) => ({
    getEmployers: builder.query<EmployersApiProps, number>(site.getEmployers()),
    getFacilities: builder.query<FacilitiesApiProps, number>(site.getFacilities()),
    getSite: builder.query<Site, number>(site.getEntity()),
    getDumpSectionsBySite: builder.query<SectionsApiProps, number>(
      site.getDumpAreaSectionsBySite(),
    ),
    getSectionsBySite: builder.query<AreaSectionApiProps, AreaSectionFilterProps>(
      site.getAreaSectionsBySite(),
    ),
    getSiteChilds: builder.query<SiteChildsApiProps, number>(site.getSiteChilds()),
    updateSite: builder.mutation<void, Pick<SiteApiProps, 'id'> & Partial<SiteApiProps>>(site.updateEntity()),
    getSiteModules: builder.query<ModulesApiProps[], Pick<ModuleParams, 'id'>>(
      site.getModules(),
    ),
    updateSiteModule: builder.mutation<void, Pick<ModulesApiProps, 'name'> & Partial<ModulesApiProps>>(site.updateModules()),
    getSiteReports: builder.query<ReportApiProps[], number>(site.getSiteReports()),
    getJobTypes: builder.query<JobTypeApiProps, number>(site.getJobTypes()),
  }),
  overrideExisting: false,
});

export const {
  useGetEmployersQuery,
  useGetFacilitiesQuery,
  useGetSiteQuery,
  useGetDumpSectionsBySiteQuery,
  useGetSectionsBySiteQuery,
  useGetSiteChildsQuery,
  useGetSiteModulesQuery,
  useUpdateSiteModuleMutation,
  useUpdateSiteMutation,
  useGetSiteReportsQuery,
  useGetJobTypesQuery,
} = siteApi;
